export {
  DuoSelectorToggleComponent,
  duoSelectorToggleData,
} from './duo-selector-toggle.component';
